import {
    Navigate,
    Route,
    Routes,
} from 'react-router-dom';

import {IndexPage} from './pages/IndexPage';
import {AddPage} from './pages/AddPage';
import {EditPage} from "./pages/EditPage.tsx";
import {useVerifiedPermissions} from "../../../hooks/useVerifiedPermissions.ts";
import {rbacActions} from "../../../config/rbac/actions.ts";


export const ApplicationsLayout = () => {

    const {allowedActions} = useVerifiedPermissions()


    return (
        <Routes>
            <Route
                path='/'
                element={
                    allowedActions.includes(rbacActions.ListApplications) ? (
                        <IndexPage/>
                    ) : (
                        <Navigate to='/'/>
                    )
                }
            />
            <Route
                path='add'
                element={
                    allowedActions.includes(rbacActions.CreateApplication) ? (
                        <AddPage/>
                    ) : (
                        <Navigate to='/applications'/>
                    )
                }
            />
            <Route
                path=':id'
                element={
                    allowedActions.includes(rbacActions.GetApplication) ? (
                        <EditPage/>
                    ) : (
                        <Navigate to='/applications'/>
                    )
                }

            >
            </Route>


        </Routes>
    );
};
